<template>
  <el-button class="btn-cancel" @click="cancel()">{{value}}</el-button>
</template>

<script>
export default {
  name: "button-cancel",
  props: {
    value: {
      type: String,
      default: "取消"
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    }
  }
};
</script>

<style scoped>
.btn-cancel {
  border: 1px solid #dcdfe6;
  color: #48576a;
  padding: 8px 16px;
  font-size: 13px;
  background-color: #f7f7f7;
  height: 32px;
}
.btn-cancel:hover {
  color: #1362ff;
  border: 1px solid #1362ff;
  background-color: #f7f7f7;
}
</style>



// WEBPACK FOOTER //
// src/components/Button/ButtonCancel.vue